import wizardEvents from 'config/trackingEvents/wizardEvents'
import webuiEvents from 'config/trackingEvents/webuiEvents'

const TRACKING_EVENTS = {
  WIZARD: wizardEvents,
  WEBUI: webuiEvents
} as const

export { TRACKING_EVENTS }
